import React from 'react';

import { withEventScope } from '@repo/event-processor';
import IconProject from '@repo/ui-icons/IconProject';
import { Button } from '@repo/ui-kit/components/core/Button';

import { NewProjectTileProps } from 'components/NewProjectTile/types';

import { NewProject, NewProjectOverlay } from './styles';

const NewProjectTile: React.FC<NewProjectTileProps> = ({ onClick }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <NewProject
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <NewProjectOverlay hovered={hovered}>
        <Button
          leftIcon={IconProject}
          name="newProjectButton"
          width="fit-content"
          onClick={onClick}
        >
          <Button.Label>New Project</Button.Label>
        </Button>
      </NewProjectOverlay>
    </NewProject>
  );
};

export default withEventScope(NewProjectTile, { module: 'newProjectTile' });
